module.exports = __webpack_public_path__ + "static/media/contacts_es.03e917cd.png";